import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import {
  createScaffolderFieldExtension,
  CustomFieldExtensionSchema,
} from '@backstage/plugin-scaffolder-react';
import { StoryPicker, StoryPickerSchema } from './StoryPicker';

export const StoryPickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'StoryPicker',
    component: StoryPicker,
    schema: StoryPickerSchema as CustomFieldExtensionSchema,
  }),
);
